import { createFileRoute } from "@tanstack/react-router";
import BulkImport from "@/pages/BulkImport";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/bulk-import/")({
  head: () => routeHead("/uk/bulk-import/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><BulkImport /></PrivateRoute>
  );
}
